import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import ReactToPrint from 'react-to-print';
import Time from '../../Time';
import '../../css/App.css'
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap';
import ReportToPrint from './ReportToPrint';

class PayrollReportCreator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportList:[],
      reportHistoryList:[],
      reportStartDate:"",
      reportEndDate:"",
      generatedDate:"",
      lookForHistory:false,
      selectedPayrollHistory:0,
      historyReport:{},
      author:this.props.user,
      saveBtnStatus:"",
      newReportCreated:false

    };
    
    this.formStartDate = React.createRef();
    this.formEndDate = React.createRef();
    this.tableToPrint = React.createRef();
    this.callPayrolls = this.callPayrolls.bind();
    this.savePayrollReport = this.savePayrollReport.bind();
    this.openHistoryWindow = this.openHistoryWindow.bind();
    this.getPayrollReport = this.getPayrollReport.bind();
    this.selectHistory = this.selectHistory.bind();
    
  }

  changePeriod = () =>{

  }

  openHistoryWindow = async() =>{
    let windowStatus = this.state.lookForHistory;
    this.setState({lookForHistory:!windowStatus})

    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };
    
    fetch("https://dashboard.realsexdoll.info/php/payroll/getpayrollhistorylist.php", requestOptions)
      .then(response => response.json())
      .then(result => this.setState({reportHistoryList:result}))
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

  }

  selectHistory = (e) =>{
    let selectedItem = e.target.value;
    this.setState({selectedPayrollHistory:selectedItem});
  }

  getPayrollReport = async() =>{
    
    let payrollReport;
    let shifts;

    var formdata = new FormData();
    formdata.append("id", this.state.selectedPayrollHistory);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    await fetch("https://dashboard.realsexdoll.info/php/payroll/getpayrollhistoryreport.php", requestOptions)
      .then(response => response.json())
      .then(result => payrollReport = result[0])
      .catch(error => console.log('error', error));

    shifts = JSON.parse(payrollReport.shifts);

    this.setState({reportList:shifts})
    this.setState({reportStartDate:payrollReport.startDate})
    this.setState({reportEndDate:payrollReport.endDate})
    this.setState({author:payrollReport.author})
    this.setState({generatedDate:payrollReport.generatedDate})
    
    this.setState({lookForHistory:false});
    
  }
  /**
   * Generate the payroll report with the hours
   * @param  {} selectedPeriod
   */
  callPayrolls = async(selectedPeriod) =>{
    
    //Cleans the report screen
    this.setState({reportList:[]});

    //First we get the starting date and the ending date of the report
    let startDate = selectedPeriod.value.start;
    let endDate = selectedPeriod.value.end;

    //Then we retrieve the information from the database
    const APIlink = "https://dashboard.realsexdoll.info/php/payroll/getpayrollreport.php?"
    let linkStartDate = "startDate="+startDate;
    let linkEndDate = "&endDate="+endDate+"T23:59:59";
    
    let APICall = APIlink+linkStartDate+linkEndDate;
    
    let fetchRequest = await fetch(APICall);
    const results = await fetchRequest.json();
    
    //console.log(results);

    //Now we process this data to create our report
    var payrollReport = [];
    //Each result represent a day of work
    for(let result of results){
      let start = new Date(result.HrStartTime)
      let end = new Date(result.HrEndTime)
      let location = result.WorkLocation;
      
      //Calculates how much time the employee worked and convert it to hours
      let millisecondsOfWork = end - start;
      let resultHours = millisecondsOfWork/3.6e+6
      let workHours=0;
      let holidayHours=0;
      let vacationHours=0;
      //This checks what time of timesheet is that and insert in the correct place
      if(location == "Office" || location == "Remote" || location == "null"){
        workHours += resultHours;
      }else if(location == "Holiday"){
        holidayHours += resultHours;
      }else if(location == "Vacation"){
        vacationHours += resultHours;
      }
      
      let employeeHoursObj = {
        name:result.Username,
        hours:workHours,
        holiday:holidayHours,
        vacation:vacationHours
      }
      
      //This looks if the employee is already in the report
      let findEmployee = payrollReport.findIndex((employee) => employee.name == result.Username);
      
      if(findEmployee < 0){
        //if it is not in the report yet it adds to it
        payrollReport.push(employeeHoursObj)
      }else{
        //Otherwise we add more hours to the employee who is already there 
        payrollReport[findEmployee].hours += workHours;
        payrollReport[findEmployee].holiday += holidayHours;
        payrollReport[findEmployee].vacation += vacationHours;
      }
      
      //Setting the state for later
      this.setState({reportStartDate:startDate})
      this.setState({author:this.props.user})
      this.setState({reportEndDate:endDate})
    }
    
    this.setState({reportList:payrollReport});
    this.setState({reportList:payrollReport});
    this.setState({generatedDate:Time.getComputerTimeDateNormal()})
    console.log(payrollReport)
    this.setState({newReportCreated:true});
    
  }

  //Records the Payroll into the database
  savePayrollReport = async() =>{

    let array = this.state.reportList;

    //This just reduce the number of figures after the . for 2
    //Example 8.99999 now is 8.99
    for(let i = 0; i < array.length; i++) {
      array[i].hours = parseFloat(array[i].hours.toFixed(2));
      array[i].holiday = parseFloat(array[i].holiday.toFixed(2));
      array[i].vacation = parseFloat(array[i].vacation.toFixed(2));
    }

    var formdata = new FormData();
    formdata.append("startdate",this.state.reportStartDate);
    formdata.append("enddate", this.state.reportEndDate);
    formdata.append("reportdate", Time.getComputerTimeDate());
    formdata.append("author", this.props.user);
    formdata.append("shifts", JSON.stringify(this.state.reportList));

    console.log(this.state.reportStartDate);
    console.log(this.state.reportEndDate);

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/payroll/savepayrollreport.php", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

      this.setState({newReportCreated:false});
  }
  render() {

    let saveBtn;
    if(this.state.newReportCreated){
      saveBtn = <button onClick={this.savePayrollReport}>Save Report</button>
    }
    
    let selectedPeriod;
    const periodOptions = Time.PayrollDates( {horizonYears: 2});
    const selectPeriods = 
      <Select
          options={periodOptions}
          value={selectedPeriod}
          onChange={this.callPayrolls}
      />

    let historyOptions;
    if(this.state.reportHistoryList.length > 0){historyOptions = this.state.reportHistoryList.map((row, index) =>
      <option value={row.id}>From {row.startDate} to {row.endDate}</option>
    )}

    let getHistory;
    if(this.state.lookForHistory){
      getHistory = 
      <div>
        <div className='pop-up payroll-history-background' onClick={this.openHistoryWindow}></div>
        <div className="container pop-up-window payroll-history-window">
          <h3 className='text-center'>Payroll History</h3>
          <div className='row d-flex justify-content-center p-3'>
            <select onChange={this.selectHistory} size={5} className="my-3">
              {historyOptions}
            </select>
          <button onClick={this.getPayrollReport}>See report</button>
          </div>
        </div>
      </div>
    }
    return(
      <div>
        {getHistory}
        <div className='pop-up payroll-creator-window' onClick={this.props.close}></div>
        <div className="container pop-up-window payroll-window payroll-creator-window">
          <h3>Payroll Generator</h3>
          <div className='row mb-3'>
              <div className='col-3'>
                <label className="form-label">Period</label>
                {selectPeriods}
              </div>
              <div className='col-9'>
                <label className="form-label"></label>
                <div className='row'>
                  <div className="col-12 d-grid gap-2 d-md-flex justify-content-md-end">
                    <ReactToPrint
                      trigger={() => <button className=''>Print Report</button>}
                      content={() => this.tableToPrint.current}
                    />
                    {saveBtn}
                    <button onClick={this.openHistoryWindow}>Report History</button>
                  </div>
                </div>
              </div>
           </div>
          <div className=''>
            <div className=''>
              <ReportToPrint 
                ref={this.tableToPrint}
                reportList={this.state.reportList}
                startDate={this.state.reportStartDate}
                endDate={this.state.reportEndDate}
                user={this.state.author}
                generatedDate={this.state.generatedDate}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PayrollReportCreator;